import { render, staticRenderFns } from "./ChangeDealAlternativeAddressModal.vue?vue&type=template&id=4434b8f5"
import script from "./ChangeDealAlternativeAddressModal.vue?vue&type=script&lang=js"
export * from "./ChangeDealAlternativeAddressModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports